module.exports = __webpack_public_path__ + "static/media/lolcat-clock.d9ddfc83.png";